import React, { ComponentType } from 'react';
import { ModalBox } from 'components/base/modal';
/**
 * Renders a component and a modal overlay
 *
 * @param Component - Base component that needs a modal
 */
export function withModalBox<T>(Component: ComponentType<T>) {
  return function WithModalBox({ ...props }) {
    return (
      <>
        <Component {...(props as T)} />
        <ModalBox />
      </>
    );
  };
}
